<div id="main-container" class="d-flex flex-column">
    <stHeader id="header-container" class="animated fadeInDown"></stHeader>

    <div id="map-modules-container" class="d-flex flex-grow-1 overflow-hidden">
        <div id="module-bar" class="flex-shrink-0 bg-light" *ngIf="!showMobileUi">
            <ul class="nav nav-pills nav-flush flex-column mb-auto text-center">
                <!-- catalog -->
                <li
                    class="nav-item"
                    *ngIf="modulesAccess.catalog"
                    [ngClass]="{active: moduleService.isModuleActive.catalog}"
                >
                    <a
                        href="javascript:void(0);"
                        class="module-icon"
                        (click)="toggleModule('catalog')"
                    >
                        <span class="fa fa-list fa-2x"></span>
                        <small>Indicateurs</small>
                    </a>
                </li>

                <!-- atac -->
                <li
                    id="icon-atac"
                    class="nav-item"
                    *ngIf="modulesAccess.atac"
                    [ngClass]="{active: moduleService.isModuleActive.atac}"
                >
                    <a
                        href="javascript:void(0);"
                        class="module-icon"
                        (click)="toggleModule('atac')"
                        [hidden]="!moduleService.showIcon.atac"
                    >
                        <img
                            id="atac-img-base"
                            height="30"
                            width="40"
                            src="../../../assets/img/atac.png"
                            [hidden]="moduleService.isModuleActive.atac"
                        />
                        <img
                            id="atac-img-selected"
                            height="30"
                            width="40"
                            hidden="true"
                            src="../../../assets/img/atac_selected.png"
                            [hidden]="!moduleService.isModuleActive.atac"
                        />
                        <small>AtAC</small>
                    </a>
                </li>

                <!-- cadastre solaire -->
                <li
                    class="nav-item"
                    *ngIf="modulesAccess.solar && moduleService.showIcon.solar"
                    [ngClass]="{active: moduleService.isModuleActive.solar}"
                >
                    <a
                        href="javascript:void(0);"
                        class="module-icon"
                        (click)="toggleModule('solar')"
                    >
                        <span class="fa fa-sun-o fa-2x"></span>
                        <small>Mon projet<br />solaire</small>
                    </a>
                </li>

                <!-- prosper réseaux -->
                <li
                    class="nav-item"
                    *ngIf="modulesAccess.prosperReseaux"
                    [ngClass]="{active: moduleService.isModuleActive.prosperReseaux}"
                    [hidden]="!moduleService.showIcon.prosperReseaux"
                >
                    <a
                        href="javascript:void(0);"
                        class="module-icon"
                        (click)="toggleModule('prosperReseaux')"
                    >
                        <svg
                            class="img-responsive w-100 h-100"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            viewBox="0, 0, 400, 481.9277108433735"
                        >
                            <g>
                                <path
                                    class="img-responsive"
                                    stroke="none"
                                    fill-rule="evenodd"
                                    d="M223.516 31.339 C 210.078 44.777,210.771 63.357,225.203 76.584 L 234.282 84.904 230.494 104.500 C 228.410 115.278,222.742 144.970,217.897 170.482 L 209.089 216.867 200.198 216.867 C 189.312 216.867,167.340 227.445,162.324 235.100 L 158.637 240.727 140.764 231.883 C 125.503 224.332,122.892 222.139,122.892 216.875 C 122.892 196.612,92.600 188.594,80.627 205.688 C 66.771 225.470,90.128 252.050,111.375 240.679 C 115.520 238.461,119.256 239.362,132.504 245.771 L 148.599 253.557 148.396 270.754 C 148.284 280.213,148.735 290.542,149.398 293.708 C 150.486 298.906,147.018 301.676,113.561 322.327 L 76.520 345.190 68.299 341.270 C 37.095 326.390,7.532 353.904,21.550 384.780 C 35.991 416.586,80.285 406.220,84.246 370.108 L 85.542 358.288 122.479 335.529 L 159.416 312.770 164.648 317.559 C 180.235 331.827,208.853 336.950,228.083 328.916 C 232.840 326.928,237.544 325.301,238.535 325.301 C 240.064 325.301,283.369 372.575,300.698 393.163 C 306.135 399.623,306.157 399.894,302.208 411.966 C 289.298 451.436,335.601 481.634,366.386 453.821 C 400.091 423.371,363.649 369.897,321.576 388.068 C 320.189 388.667,303.738 372.063,285.018 351.170 L 250.981 313.183 256.983 302.445 C 260.337 296.443,263.591 285.827,264.360 278.376 L 265.736 265.046 277.564 261.534 C 288.127 258.397,290.253 258.432,297.454 261.866 C 322.742 273.925,339.617 240.369,315.165 226.645 C 306.663 221.873,296.819 225.319,290.377 235.324 C 285.316 243.183,260.023 253.120,258.203 247.964 C 256.297 242.564,244.011 230.095,234.882 224.294 L 225.090 218.072 237.395 152.459 C 244.163 116.372,250.174 86.521,250.754 86.123 C 251.333 85.725,255.820 83.577,260.725 81.349 C 292.724 66.817,280.759 21.723,244.897 21.696 C 234.418 21.688,232.140 22.715,223.516 31.339 M344.122 412.690 C 344.692 417.490,346.405 419.163,351.330 419.734 C 360.949 420.848,361.422 428.559,351.989 430.446 C 346.211 431.601,344.578 433.188,344.578 437.651 C 344.578 441.767,343.226 443.373,339.759 443.373 C 336.225 443.373,334.940 441.767,334.940 437.349 C 334.940 433.063,333.635 431.325,330.416 431.325 C 324.989 431.325,319.444 425.315,321.622 421.792 C 322.476 420.409,325.823 419.277,329.058 419.277 C 333.613 419.277,334.940 418.009,334.940 413.655 C 334.940 402.810,342.848 401.979,344.122 412.690 "
                                ></path>
                            </g>
                        </svg>
                        <small
                            >Prosper <br />
                            Réseaux</small
                        >
                    </a>
                </li>

                <!-- filter -->
                <li
                    class="nav-item"
                    *ngIf="modulesAccess.filters && moduleService.showIcon.filters"
                    [ngClass]="{active: moduleService.isModuleActive.filters}"
                >
                    <a
                        href="javascript:void(0);"
                        class="module-icon"
                        (click)="toggleModule('filters')"
                    >
                        <span class="fa fa-filter fa-2x"></span>
                        <small>Filtres</small>
                    </a>
                </li>

                <!-- indicator parameter -->
                <li
                    class="nav-item"
                    *ngIf="modulesAccess.indicatorParameters && moduleService.showIcon.indicatorParameters"
                    [ngClass]="{active: moduleService.isModuleActive.indicatorParameters}"
                >
                    <a
                        href="javascript:void(0);"
                        class="module-icon"
                        (click)="toggleModule('indicatorParameters')"
                    >
                        <span class="fa fa-cog fa-2x"></span>
                        <small>Paramétres</small>
                    </a>
                </li>

                <!-- map parameter -->
                <li
                    class="nav-item"
                    *ngIf="modulesAccess.mapParameters"
                    [ngClass]="{active: moduleService.isModuleActive.mapParameters}"
                >
                    <a
                        href="javascript:void(0);"
                        class="module-icon"
                        (click)="toggleModule('mapParameters')"
                    >
                        <span class="fa fa-globe fa-2x"></span>
                        <small>Carte</small>
                    </a>
                </li>

                <!-- import -->
                <li
                    class="nav-item"
                    *ngIf="modulesAccess.upload"
                    [ngClass]="{active: moduleService.isUploadModalActive}"
                >
                    <a href="javascript:void(0);" class="module-icon" (click)="openImportModal()">
                        <span class="fa fa-upload fa-2x"></span>
                        <small>Import</small>
                    </a>
                </li>

                <!-- export -->
                <li
                    class="nav-item"
                    *ngIf="modulesAccess.download && moduleService.showIcon.download"
                    [ngClass]="{active: moduleService.isModuleActive.download}"
                >
                    <a
                        href="javascript:void(0);"
                        class="module-icon"
                        (click)="toggleModule('download')"
                    >
                        <span class="fa fa-download fa-2x"></span>
                        <small>Export</small>
                    </a>
                </li>

                <!-- informations -->
                <li
                    class="nav-item"
                    *ngIf="modulesAccess.informations"
                    [ngClass]="{active: moduleService.isModuleActive.informations}"
                >
                    <a
                        href="javascript:void(0);"
                        class="module-icon"
                        (click)="toggleModule('informations')"
                    >
                        <span class="fa fa-info fa-2x"></span>
                        <small>Informations</small>
                    </a>
                </li>

                <!--  manual -->
                <li
                    class="nav-item"
                    *ngIf="modulesAccess.manual"
                    [ngClass]="{active: moduleService.isModuleActive.informations}"
                >
                    <a href="{{ manual }}" class="module-icon" download>
                        <span class="fa fa-2x fa-book"></span>
                        <small>Manuel</small>
                    </a>
                </li>
            </ul>
        </div>

        <div class="d-flex flex-grow-1" [ngClass]="{'overflow-auto': !showMobileUi}">
            <div
                id="left-panel"
                [ngClass]="{'w-33': moduleService.isBaseModuleOpen, 'wpx-510': moduleService.isModuleActive.atac || moduleService.isModuleActive.prosperReseaux, 'wpx-700': moduleService.isModuleActive.solar, 'vw-100': showMobileUi && (moduleService.isBaseModuleOpen || moduleService.isPluginOpen)}"
            >
                <indicator-catalog [hidden]="!modulesAccess.catalog"></indicator-catalog>
                <indicator-filter *ngIf="modulesAccess.filters"></indicator-filter>

                <atac *ngIf="modulesAccess.atac"></atac>
                <cadastreSolaire *ngIf="modulesAccess.solar"></cadastreSolaire>
                <prosperReseaux *ngIf="modulesAccess.prosperReseaux"></prosperReseaux>

                <indicator-parameters
                    *ngIf="modulesAccess.indicatorParameters"
                ></indicator-parameters>
                <mapBoundaries *ngIf="modulesAccess.mapParameters"></mapBoundaries>
                <download *ngIf="modulesAccess.download"></download>
                <info *ngIf="modulesAccess.informations"></info>
            </div>

            <div id="center-panel" class="flex-grow-1 h-100">
                <div
                    id="map"
                    class="w-100 h-100"
                    [ngClass]="{'mobile-map': showMobileUi, 'vw-100': showMobileUi}"
                >
                    <map-attributions></map-attributions>
                    <map-legend></map-legend>
                    <cadastre-solaire-cta-mobile *ngIf="showMobileUi"></cadastre-solaire-cta-mobile>
                    <search-bar></search-bar>
                    <load-territories></load-territories>
                    <dashboard-control *ngIf="modulesAccess.results"></dashboard-control>

                    <div id="map-loader" *ngIf="showLoaderCarte">
                        <i class="fa fa-spinner fa-pulse fa-4x fa-fw"></i>
                    </div>
                </div>
            </div>

            <div
                id="right-panel"
                class="w-33"
                *ngIf="modulesAccess.results"
                [hidden]="!dashboardService.moduleDashboard.isOpen"
            >
                <dashboard-tab> </dashboard-tab>
            </div>
        </div>
    </div>
</div>
